import { render, staticRenderFns } from "./CollectionVideoPreview.vue?vue&type=template&id=4548e93f&scoped=true&"
import script from "./CollectionVideoPreview.vue?vue&type=script&lang=js&"
export * from "./CollectionVideoPreview.vue?vue&type=script&lang=js&"
import style0 from "./CollectionVideoPreview.vue?vue&type=style&index=0&id=4548e93f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4548e93f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4548e93f')) {
      api.createRecord('4548e93f', component.options)
    } else {
      api.reload('4548e93f', component.options)
    }
    module.hot.accept("./CollectionVideoPreview.vue?vue&type=template&id=4548e93f&scoped=true&", function () {
      api.rerender('4548e93f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/modals/CollectionVideoPreview.vue"
export default component.exports